import { useQuery, type UseQueryResult } from 'react-query';
import {
  CharterFilingService,
  type Wealthlane_CapTable_Dtos_CharterFiling_StockClassDetailDto,
} from '@wealthlane/api-services/wealthlane-captable-service';

const useGetShareClassDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  charterFilingId?: string | null
): UseQueryResult<Wealthlane_CapTable_Dtos_CharterFiling_StockClassDetailDto[] | undefined, unknown> => {
  return useQuery(
    ['getShareClassDetails', charterFilingId],
    async () => {
      if (charterFilingId) {
        return await handleRequest(
          CharterFilingService.getApiCapTableApiAppCharterFilingShareClassDetails(charterFilingId)
        );
      }
    },
    {
      enabled: charterFilingId != null && charterFilingId !== '',
    }
  );
};

export default useGetShareClassDetails;
